<template>
  <div class="page" v-wechat-title="数字文博云讲解">
    <!--搜索-->
    <div class="station-top-bar border-box box">
      <form class="station-search-box flex" @click.stop="getFocus">
        <div class="station-search-bar border-box">
          <img class="station-search-icon" src="../../assets/icon-search.png" alt="">
          <input type="text" class="station-search-input"  placeholder="搜索内容" value="" v-model='inputValue' />
        </div>
      </form>
    </div>

    <!--搜索弹窗-->
    <div class="search-page" v-show="searchShow==1">
      <div class="search-box">
        <form class="search-form border-box" v-on:submit.prevent="search">
          <span @click.stop="searchShow=0"><img src="../../assets/icon_28.png" alt=""></span>
          <input type="search" placeholder="搜索内容" v-model='inputValue'  ref="searchInp"  id="searchInp" />
          <div @click.stop='search' v-if="searchList.length<=0||inputValue==''">搜索</div>
          <div style="color:#ff5767;" @click.stop="searchList=[],inputValue=''" v-else>取消</div>
        </form>
      </div>
      <div class="search-scoll" id="scollBox">
        <div class="search-list">
          <div class="search-li" :class="item.type=='spot'?'search-li1':''" v-for="(item,index) in searchList" :key="index" @click="selectSearch(index)">
            <div v-html="initTxt(item.name)"></div>
            <p v-if="item.type=='spot'"><font v-html="initTxt(item.name)"></font></p>
          </div>
        </div>
        <p v-show="searchList.length>0" class="load-tip1" id="loadTip" style="height: auto;">{{loadText1}}</p>
      </div>
    </div>

    <!--列表-->
    <div v-if="root!=null && root.length>0">
      <div style="border-radius: .06rem;overflow: hidden;height: 3.4rem;"><img class="img" src="https://filewc.geeker.com.cn/jpjs/upload/default/banner-01.jpg" alt=""></div>

      <div class="list-item" v-for="(item,index) in root" :key="index">
        <div class="list-item-con" @click="toViewDetail(item.id)">
          <p class="list-item-name hide">{{item.name}}</p>
          <img class="img" v-lazy="item.logo">
          <div class="list-item-img">
            <div class="img-box" v-for="(ite,index) in item.spots" @click.stop="toSpotDetail(item.id,ite.id)">
              <img class="img" v-lazy="ite.logo"  alt="">
              <span class="hide">{{ite.name}}</span>
            </div>
          </div>
          <div class="sel-more">
            了解更多
            <img src="../../assets/city_icon06.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <p class="load-tip" v-if="loadOver">{{loadText}}</p>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>
<script>
  import P400 from '../../components/P400'
  import {uploadUserBrowse,citySiteMuseum} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, getHotCity1} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore ,scollLoadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        cityInfo: { citycode: "1", city: "全国", address: "" },
        inputValue: '',//搜索关键词
        loadEnd: false, //数据加载结束则赋值为true
        code:'',
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        searchList:[],//搜索列表
        searchShow: 0, //是否显示搜索窗
        searchFocus:false,
        searchTip:0,
        page: 1,
        rows:5,
        pageAlert:1,//弹窗内分页 page
        rowsAlert:15,//弹窗内分页 rows
        root: [], //列表
        total:'',//列表总条数
        loadText: "加载更多",
        loadOver: false, //是否加载结束
        loadText1: '', //弹窗列表提示
        history: [], //历史记录
        P400: 0, //系统维护中
      }
    },
    computed: {},

    beforeRouteLeave (to, from, next) {
      if(to.path.indexOf('waterfall') > -1){
        to.meta.keepAlive = false;
      }
      next();
    },
    created(){
      let self = this;
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.code = this.$route.query.code;
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      let cityInfo = getStore("cityInfo");
      if (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") {
        getCityInfo(function (res) {
          self.latlng = res;
          self.cityInfo = { citycode: "1", city: "全国", address: "" };
          setStore("cityInfo",self.cityInfo);
          self.initData(self.page);
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData(self.page);
        });
      }
      let history = getStore("history", 1) || "";
      if (history) {
        this.history = history.history
      }
      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
      document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
    },
    methods: {
      //初始化：获取景区数据
      async initData(page){
        let res = await citySiteMuseum({
          TimeStamp: this.TimeStamp,
          key:this.inputValue,
          code:this.code,
          page: page,
          rows: this.rows
        });
        if(res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          let root = res.data.data
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
          this.loadOver = true;

          var share = res.data.share;
          let link = '/city-museum-list?code=' + this.code + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = '数字文博云讲解';
            let desc = '保护传统文化，传承千年文明';
            let img = '';
            wxShareme(title, desc, img, link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }
        }else {
          this.$loading.hide();
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //获取搜索内容信息
      async initSearchData(page){
        let res = await citySiteMuseum({
          TimeStamp: this.TimeStamp,
          key:this.inputValue,
          code:this.code,
          page: page,
          rows: this.rowsAlert,
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.searchTip = 1;
          this.searchTotal = res.data.total;
          let searchList = res.data.data;
          console.log(page,this.searchTotal,this.rowsAlert,page >= Math.ceil(this.searchTotal / this.rowsAlert));
          if (page >= Math.ceil(this.searchTotal / this.rowsAlert)) {
            this.loadText1 = '已经到底了'
          } else {
            this.loadText1 = '加载更多'
          }
          if (searchList.length > 0) {
            this.searchList = [...this.searchList, ...searchList];
          } else {
            if (page == 1) {
              this.searchList = [];
              this.$toast('暂无搜索结果');
            } else {
              this.loadText1 = '已经到底了'
            }
          }
        }else {
          this.$toast(res.errmsg)
        }

      },

      //上传浏览数据
      async sendUserBrowse(){
        let res = await uploadUserBrowse({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //发送搜索信息inputVaule
      search(){
        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if(this.inputValue == ''){
          this.$toast('请输入搜索关键词');
          return;
        }
        this.$loading.show('数据加载中');
        this.pageAlert = 1;
        this.searchList = [];
        this.initSearchData(this.pageAlert)
      },

      //选择搜索结果
      selectSearch: function(index){
        this.toViewDetail(this.searchList[index].id)
        this.searchShow = 0;
      },

      //标注搜索结果
      initTxt: function (txt){
        return txt.replace(this.inputValue, '<span style="color: #ff8a00">'+ this.inputValue + '</span>')
      },


      getFocus(){
        this.searchShow=1;
        this.searchList=[];
        this.$nextTick( () =>{
          this.$refs.searchInp.focus()
        } )
      },

      toViewDetail(id){
        this.$router.push({
          path: `/view-detail?${'shopid='+ id + '&code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },
      toSpotDetail(id,idd){
        this.$router.push({
          path: `/spot-detail?${'shopid='+ id + '&spotid='+ idd + '&code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      handleFun1: function (){
        let self = this;
        self.$nextTick(function() {
          scollLoadMore(self,'scollBox','loadTip',function(){
            self.pageAlert += 1;
            self.initSearchData(self.pageAlert);
          });
        })
      },



  },
    components: {
      P400
    },

    watch:  {
      searchShow(newVal,oldVal){
        if(newVal == 1 ){
          document.getElementById("scollBox").addEventListener("scroll",this.handleFun1)
        }else {
          document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
        }
      }
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if (num > 10000) {
          num = (num / 10000).toFixed(2) + '万'
        } else if (num > 1000) {
          num = (num / 1000).toFixed(2) + '千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  .page{padding: 0 .26rem;background-color:#fff}

  /*搜索*/
  .station-top-bar{position: fixed; top: 0; left: 0; z-index: 9; padding: .1rem 1.9rem; width: 100%; height: .68rem; background: transparent;}
  .station-search-bar{display: block; margin-top: 0; height: .48rem; border-radius: .5rem; line-height: .48rem; background: rgba(255,255,255,.5);}
  .station-search-input{width: 80%;height: .48rem;line-height: .48rem;color: #fff;background: transparent;}
  .station-search-icon{position:absolute;top:50%;right:0;z-index:999;padding:.2rem .2rem .2rem 0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}

  /*列表*/
  .list-item{width: 100%!important;height: 4.25rem;margin-top:.24rem;border-radius: .18rem;}
  .list-item-con{position:relative;width: 100%;height: 100%;border-radius: .18rem;box-shadow:0 0 .2rem #d0d0d0;}
  .list-item-con img{width:100%;height:2rem;border-radius: .18rem .18rem 0 0;}
  .list-item-name{position: absolute;top:1rem;left:.18rem;right:.18rem;font: bold .48rem "Microsoft YaHei";color: #fff;}
  .sel-more{position: absolute;bottom: .34rem;right: -.16rem;z-index:2;height: .5rem;padding-left:.22rem;padding-right:.12rem;font: .24rem/.5rem "Microsoft YaHei";color: #fff;border-radius: .3rem;background-image: linear-gradient(to right,#fccd5b,#faaf39);}
  .sel-more img{float: right;width: .26rem;height: .26rem;margin-left: .12rem;margin-top: .12rem;border-radius: 50%;}
  .list-item-img{width:100%;margin-top: .28rem;}
  .img-box{float:left;width: 1.4rem;margin-left: .22rem;}
  .img-box img{display:block;width:100%;height:1.4rem;border-radius: .08rem;object-fit: cover;}
  .img-box span{display: block;width: 100%;margin-top:.06rem;font:bold .2rem "Microsoft YaHei";color: #383838;text-align: center;}


  /*搜索页面*/
  .search-page{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 10; background-color: #edefed;}
  .search-box{ padding-top: .12rem; padding-bottom: .19rem; }
  .search-form{ position: relative; display: block; padding: .16rem 1.2rem .16rem .72rem; height: 1rem; background-color: #fff; }
  .search-form span{ position: absolute; left: 0; top: .16rem; width: .72rem; height: .68rem; }
  .search-form span img{ width: .16rem; height: .29rem; margin: .2rem 0 0 .3rem }
  .search-form div{ position: absolute; right: 0; top: .16rem; width: 1.2rem; height: .68rem; line-height: .68rem; font-size: .3rem; color: #333; text-align: center; }
  .search-form input{ display: block; padding: .09rem .25rem; width: 100%; height: .68rem; line-height: .68rem; font-size: .26rem; color: #333; background-color: #f5f5f5; border-radius: .12rem; overflow: hidden; }
  .search-scoll{ width: 100%; position: absolute;top: 1.31rem;bottom: 0;left: 0;width: 100%;overflow-y: scroll; background-color: #fff; }
  .search-list{padding: 0 .32rem 0 .26rem; }
  .search-li{ position: relative;}
  .search-li img{ position: absolute; left: 0; top: .3rem; width: .28rem; height: .34rem; }
  .search-li div{ padding: .3rem 0 .26rem; width: 100%; height: .34rem; line-height: .34rem; font-size: .26rem; color: #666; border-bottom: .01rem solid #e5e5e5; }
  .search-li1 div{ padding: .2rem 0 .08rem; border-bottom: 0; }
  .search-li1 img{ left: .01rem; top: .32rem; height: .28rem; }
  .search-li p{ padding-bottom: .2rem; line-height: .2rem; font-size: .18rem; color: #b2b2b2; border-bottom: .01rem solid #e5e5e5; }
  .search-li span{ font-weight: normal; color: #ff8a00; }

  /*底部加载样式*/
  .load-tip1{width:100%; height:100%; padding: .15rem 0 .25rem; vertical-align:top; text-align:center; margin-top: .15rem; font-size:.2rem; color:#999; }
</style>



// WEBPACK FOOTER //
// src/page/city-site/city-museum-list.vue